import React from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import AccountTypeBadge from '../../../components/general/AccountTypeBadge';

interface ProfileCardProps {
  profileImage?: string;
  firstName: string;
  lastName: string;
  email?: string;
  userType: string;
  accountType?: string;
  age?: number;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  profileImage,
  firstName,
  lastName,
  email,
  userType,
  accountType,
  age
}) => {
  const getInitials = () => {
    return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
  };

  const getDisplayName = () => {
    return `${firstName || ''} ${lastName || ''}`.trim() || 'User';
  };

  const getUserTypeLabel = () => {
    // Convert user type to uppercase badge label
    if (userType.toLowerCase().includes('child')) return 'CHILD';
    if (userType.toLowerCase().includes('host')) return 'HOST';
    if (userType.toLowerCase().includes('coach')) return 'COACH';
    if (userType.toLowerCase().includes('parent')) return 'PARENT';
    return 'USER';
  };

  return (
    <View style={styles.container}>
      {profileImage ? (
        <Image
          source={{ uri: profileImage }}
          style={styles.image}
          resizeMode="cover"
        />
      ) : (
        <View style={styles.avatarPlaceholder}>
          <Text style={styles.avatarText}>{getInitials()}</Text>
        </View>
      )}
      <View style={styles.info}>
        {userType.toLowerCase().includes('child') ? (
          <View style={styles.userTypeBadge}>
            <Text style={styles.userTypeText}>
              {getUserTypeLabel()}
            </Text>
          </View>
        ) : (
          <AccountTypeBadge accountType={accountType || userType} compact />
        )}
        <Text style={styles.userName}>{getDisplayName()}</Text>
        {email && <Text style={styles.userEmail}>{email}</Text>}
        {age && <Text style={styles.userAge}>Age: {age}</Text>}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginBottom: 30,
    flex: 1,
    minWidth: 300,
  },
  image: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 15,
    borderWidth: 1,
    borderColor: 'grey',
  },
  avatarPlaceholder: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: '#4CAF50',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
    borderWidth: 1,
    borderColor: 'grey',
  },
  avatarText: {
    color: '#fff',
    fontSize: 36,
    fontWeight: '600',
  },
  info: {
    marginLeft: 20,
    justifyContent: 'center',
    flex: 1,
  },
  userTypeBadge: {
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 4,
    alignSelf: 'flex-start',
    backgroundColor: '#3C8248',
  },
  userTypeText: {
    fontSize: 10,
    color: '#FFFFFF',
    fontWeight: '700',
    letterSpacing: 1,
  },
  userName: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 4,
    marginTop: 8,
    color: '#333',
  },
  userEmail: {
    fontSize: 14,
    color: '#666',
    marginBottom: 4,
  },
  userAge: {
    fontSize: 14,
    color: '#666',
    marginBottom: 4,
  },
});

export default ProfileCard; 